import styled from 'styled-components';
import { Colors, Breakpoints } from 'styles/Constants';
import CalendarWrapper from 'components/Calendar/StyledCalendar';
import StyledCalendarInput from 'components/Calendar/CalendarInput/StyledCalendarInput';

export const SelectContainer = styled.div`
  width: 140px;
  select {
    width: 100% !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #979797 !important;
    background-color: transparent !important;
    color: #3e66fe !important;
    font-weight: 500 !important;
    text-transform: uppercase !important;
  }
`;

export const ButtonDownload = styled.div`
  button {
    padding: 5px 20px;
    font-size: 12px;
    text-align: center;
    border: 1px solid ${Colors.primaryDarkBlue};
    background-color: ${Colors.primaryDarkBlue};
    background-image: linear-gradient(136deg, #3e65fe, #3ebbfe);
    svg {
      margin: 0;
      width: 15px;
      height: 15px;
    }

    @media (max-width: ${Breakpoints.medium}) {
      width: 100%;
      padding: 8px 20px;
    }
  }
`;

export const FiltersForm = styled.div`
  text-align: center;
  display: block;
  flex-wrap: wrap;

  div.dropdown-filter-content__control {
    width: 100%;
    @media (max-width: ${Breakpoints.medium}) {
      width: 100% !important;
    }
  }

  div.dropdown-filter-content__menu {
    @media (max-width: ${Breakpoints.medium}) {
      width: 95% !important;
    }
  }

  div.dropdown-filter-container {
    @media (max-width: ${Breakpoints.medium}) {
      margin-bottom: 15px;
    }
  }
`;

export const FirstFilters = styled.div`
  display: grid;
  grid-template-columns: 4fr 2fr 3fr 3fr;
  gap: 15px;
  align-items: center;

  /* Estilos para tablets */
  @media (max-width: ${Breakpoints.large}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'search search'
      'filter-label points'
      'group group';
  }

  /* Estilos para móviles */
  @media (max-width: ${Breakpoints.medium}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'search'
      'filter-label'
      'points'
      'group';
    gap: 10px;
  }

  input {
    /* El input de búsqueda ocupará toda el área asignada */
    @media (max-width: ${Breakpoints.large}) {
      grid-area: search;
      margin-right: 0;
    }
  }

  span.filter-by-label {
    margin: 20px auto;
    display: block;
    text-align: center;

    @media (min-width: ${Breakpoints.medium}) {
      display: inline;
      margin: 0 20px;
    }

    @media (max-width: ${Breakpoints.large}) {
      grid-area: filter-label;
      margin: 0;
      align-self: center;
    }

    @media (max-width: ${Breakpoints.medium}) {
      text-align: left;
      margin: 5px 0;
    }
  }

  /* Estilos para el dropdown de points */
  > div:nth-of-type(1) {
    @media (max-width: ${Breakpoints.large}) {
      grid-area: points;
    }
  }

  /* Estilos para el dropdown de groups */
  > div:nth-of-type(2) {
    @media (max-width: ${Breakpoints.large}) {
      grid-area: group;
    }
  }
`;

export const SecondFilters = styled.div`
  display: grid;
  grid-template-columns: 4fr 3fr 3fr 2fr;
  gap: 15px;
  align-items: center;
  margin-top: 20px;

  /* Estilos para tablets */
  @media (max-width: ${Breakpoints.large}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'period-type period-value'
      'year download';
    margin-top: 15px;
  }

  /* Estilos para móviles */
  @media (max-width: ${Breakpoints.medium}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'period-type'
      'period-value'
      'year'
      'download';
    gap: 10px;
    margin-top: 10px;
  }

  /* Asignar áreas específicas a cada elemento */
  > div:nth-of-type(1) {
    @media (max-width: ${Breakpoints.large}) {
      grid-area: period-type;
    }
  }

  > div:nth-of-type(2) {
    @media (max-width: ${Breakpoints.large}) {
      grid-area: period-value;
    }
  }

  > div:nth-of-type(3) {
    @media (max-width: ${Breakpoints.large}) {
      grid-area: year;
    }
  }

  ${ButtonDownload} {
    @media (max-width: ${Breakpoints.large}) {
      grid-area: download;
      justify-self: center;
    }

    @media (max-width: ${Breakpoints.medium}) {
      justify-self: start;
      margin-top: 10px;
    }
  }

  ${StyledCalendarInput} {
    border: none;
    border-bottom: 0.85px solid ${Colors.inactive};
    border-radius: 0;
    max-width: 300px;

    &:hover,
    &:focus-within {
      border-bottom: 0.85px solid ${Colors.primaryDarkBlue};
    }

    label {
      color: ${Colors.primaryDarkBlue};
      text-transform: uppercase;
    }

    @media (max-width: ${Breakpoints.large}) {
      max-width: 100%;
    }
  }

  ${CalendarWrapper} {
    padding: 0 10px 12px;
  }
`;
